"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHideKnockList = void 0;
var _react = require("react");
var useHideKnockList = exports.useHideKnockList = function useHideKnockList(isKnockListOpen, toggleKnockList) {
  var stats = {
    status: 'noMouseDown'
  };
  var handler = (0, _react.useCallback)(function (e) {
    if (!isKnockListOpen) {
      return stats.status = 'noPopover';
    }
    stats.status = 'mouseDown';
    toggleKnockList(e);
  }, [isKnockListOpen, toggleKnockList, stats]);
  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', handler, false);
    //remove added event on unmount
    return function () {
      return document.removeEventListener('mousedown', handler);
    };
  }, [handler]);
  return {
    stats: stats
  };
};